module.exports = __webpack_public_path__ + "static/4-Dining-688ee6552492a9420df9cafd8c6d5c0e.jpg";